import { render } from "./BtnName.vue?vue&type=template&id=75a12982"
import script from "./BtnName.vue?vue&type=script&lang=js"
export * from "./BtnName.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__